// src/components/DevStream/EventCardDetails.js
import React from "react";
import "./DevStream.css";
import JsonHighlight from "../../JsonHighlight";

/**
 * EventCardDetails - Expanded section showing full event data
 *
 * Features:
 * - Webhook headers with copy button
 * - Event body (raw JSON) with copy button
 * - Developer metadata with copy button
 * - Uses JsonHighlight component for syntax highlighting
 */
const EventCardDetails = ({
  webhookHeaders,
  rawEventBody,
  eventMetadata,
  onCopySection,
}) => {
  return (
    <div className="event-card-expanded">
      {webhookHeaders && (
        <div className="event-headers-section">
          <div className="section-header">
            <div className="section-label">Event Headers:</div>
            <button
              className="copy-section-btn"
              onClick={(e) =>
                onCopySection(e, webhookHeaders, "copy-section-btn")
              }
              title="Copy headers to clipboard"
            >
              📋
            </button>
          </div>
          <div className="event-headers-content">
            <JsonHighlight data={webhookHeaders} />
          </div>
        </div>
      )}

      <div className="event-body-section">
        <div className="section-header">
          <div className="section-label">Event Body:</div>
          <button
            className="copy-section-btn"
            onClick={(e) => onCopySection(e, rawEventBody, "copy-section-btn")}
            title="Copy body to clipboard"
          >
            📋
          </button>
        </div>
        <div className="event-card-json">
          <JsonHighlight data={rawEventBody} />
        </div>
      </div>

      <div className="dev-metadata-section">
        <div className="section-header">
          <div className="section-label">Romanworks Developer Metadata:</div>
          <button
            className="copy-section-btn"
            onClick={(e) => {
              onCopySection(e, eventMetadata, "copy-section-btn");
            }}
            title="Copy metadata to clipboard"
          >
            📋
          </button>
        </div>
        <div className="event-card-json">
          <JsonHighlight data={eventMetadata} />
        </div>
      </div>
    </div>
  );
};

export default EventCardDetails;
